import { Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { PropertyCard } from "./PropertyCard";
import TopBanner from "./TopBanner";
import SearchButton from "./SearchButton";
import {
  allPropertiesSelector,
  setAllProperties,
} from "../redux/allPropertiesSlice";
import {
  clearReduxSearchQuery,
  selectSearchQuerySelector,
} from "../redux/searchQuery";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setPropertyDetails, setUid } from "../redux/propertyIDandSN";
import { Link, useParams } from "react-router-dom";
import axiosInstance from "../Axios/axios";
import banner from "../assets/banner.jpg";
import LogOutButton from "./LogOutButton";
import Cookies from "js-cookie";
import CustomLoader from "./CustomLoader";

const PropertyList = () => {
  const allProperties = useSelector(allPropertiesSelector);
  const dispatch = useDispatch();
  // const [eCardLink, setEcardLink] = useState("");
  const { uid } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const reduxQuerySelector = useSelector(selectSearchQuerySelector);
  const [managerID, setManagerID] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchDone, setSearchDone] = useState(false);
  const SES = Cookies.get("SES");
  const spitimou_account = Cookies.get("spitimou_account");

  // console.log("allProperties", allProperties);

  const initialData = [
    {
      url: "?app=api_re_list",
      key: "lkjads9uasdkj0er9ujerkjlkdjf09dufdlkfj",
      reducer: setAllProperties,
      uid, // need to change after htaccess fixed
    },
  ];

  const fetchInitialData = () => {
    initialData.map((data) => {
      let formData = new FormData();
      formData.append("key", data.key);
      formData.append("uid", data.uid);
      formData.append("SES", SES);

      axiosInstance.post(data.url, formData).then((response) => {
        // Extract only serializable parts of the response
        const serializedResponse = {
          data: response.data, // Serialized response data
          headers: {
            contentType: response.headers["content-type"], // Specific serialized headers
            contentLength: response.headers["content-length"],
          },
        };

        // Dispatch the serialized response to the Redux store
        dispatch(data.reducer(serializedResponse));

        // Set manager ID if available
        setManagerID(response.data?.manager_id);
        sessionStorage.setItem("mid", response.data.manager_id);

        console.log(response); // Original response for debugging
      });
    });
  };

  useEffect(() => {
    dispatch(setUid(uid));
    if (!allProperties.length) {
      fetchInitialData();
    }
  }, []);

  // useEffect(() => {
  //   if (allProperties.data?.adv) {
  //     const htmlString = allProperties.data.adv;
  //     const firstLink = htmlString.match(/https?:\/\/[^"]+/)[0];
  //     setEcardLink(firstLink);
  //   }
  // }, [allProperties.data?.adv]);

  const handleListCardClick = (propertyId, propertySecureNum) => {
    dispatch(setPropertyDetails({ propertyId, propertySecureNum }));
  };

  const handleClear = () => {
    dispatch(clearReduxSearchQuery());
  };
  const reloadPage = () => {
    window.location.reload();
  };

  // console.log(allProperties);

  useEffect(() => {
    // const url = window.location.href;
    // const modifiedUrl = url.replace(`${127}`, "");
    // setNewUrl(modifiedUrl);
    // console.log("modifiedUrl", newUrl);
    // console.log("currentUrl", url);
  }, []);

  const apiFieldMap = {
    deal_type: "deal_type",
    re_type: "re_type",

    square_from: "square_from",
    square_to: "square_to",

    price_from: "price_from",
    price_to: "price_to",

    city: "city",
    state: "state",
    address: "street",
    area: "area",

    rooms_from: "rooms_from",
    rooms_to: "rooms_to",

    floor_from: "floor_from",
    floor_to: "floor_to",

    // checkboxes
    furnished: "furnished",
    pool: "pool",
    air_con: "air_con",
    parking: "parking",
    elevator: "elevator",
    disabled: "disabled",
    storage: "storage",
    door_keeper: "door_keeper",
    reconditioned: "reconditioned",

    // currency / coin
    coin: "coin",
  };

  const searchQueryData = [
    {
      url: "?app=api_re_list",
      key: "lkjads9uasdkj0er9ujerkjlkdjf09dufdlkfj",
      reducer: setAllProperties,
      uid: uid,
      rooms_from: reduxQuerySelector.rooms_from,
      rooms_to: reduxQuerySelector.rooms_to,
      deal_type: reduxQuerySelector.deal_type,
      re_type: reduxQuerySelector.re_type,
      square_from: reduxQuerySelector.square_from,
      square_to: reduxQuerySelector.square_to,
      metrics: reduxQuerySelector.metrics,
      address: reduxQuerySelector.address,
      state: reduxQuerySelector.state,
      city: reduxQuerySelector.city,
      area: reduxQuerySelector.area,
      price_from: reduxQuerySelector.price_from,
      price_to: reduxQuerySelector.price_to,
      currency: reduxQuerySelector.currency,
      rooms_from: reduxQuerySelector.rooms_from,
      rooms_to: reduxQuerySelector.rooms_to,
      floor_from: reduxQuerySelector.floor_from,
      floor_to: reduxQuerySelector.floor_to,
      furnished: reduxQuerySelector.furnished,
      pool: reduxQuerySelector.pool,
      door_keeper: reduxQuerySelector.door_keeper,
      disabled: reduxQuerySelector.disabled,
      storage: reduxQuerySelector.storage,
      parking: reduxQuerySelector.parking,
      air_con: reduxQuerySelector.air_con,
      elevator: reduxQuerySelector.elevator,
      reconditioned: reduxQuerySelector.reconditioned,
    },
  ];

  const fetchSearchResultData = () => {
    setSearchLoading(true);
    setSearchDone(false);
    let formData = new FormData();
    formData.append("key", searchQueryData[0].key);
    formData.append("uid", searchQueryData[0].uid);
    formData.append("SES", SES); // REQUIRED

    Object.entries(reduxQuerySelector).forEach(([key, value]) => {
      if (value !== undefined && value !== "" && apiFieldMap[key]) {
        formData.append(apiFieldMap[key], value);
      }
    });

    axiosInstance
      .post(searchQueryData[0].url, formData)
      .then((response) => {
        dispatch(
          setAllProperties({
            data: response.data,
            headers: response.headers, // <-- REQUIRED
          })
        );
        // console.log("SEARCH RESPONSE", response.data);
        setIsLoading(false);
        setSearchLoading(false);
        setSearchDone(true);
      })
      .catch((error) => {
        console.error("Search error:", error);
        setIsLoading(false);
        setSearchLoading(false);
        setSearchDone(true);
      });
  };
  // console.log("qSelector", reduxQuerySelector);

  useEffect(() => {
    if (Object.keys(reduxQuerySelector).length > 0) {
      fetchSearchResultData();
    }
  }, [reduxQuerySelector]);

  return (
    <Grid
      container
      sx={{ width: "100%", maxWidth: "100%", backgroundColor: "#F9FBFC" }}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Grid
        container
        justifyContent={"flex-start"}
        alignItems={"center"}
        size={12}
        sx={{ width: "100%" }}
      >
        <Grid item sx={{ width: "100%" }}>
          <TopBanner mainTopImage={banner} />
        </Grid>
      </Grid>
      <Grid container sx={{ width: "100%" }}>
        {spitimou_account === 0 ? (
          <Grid item xs={12} sx={{ pt: 2 }}>
            <Grid
              container
              justifyContent={{ xs: "flex-start", md: "center" }}
              sx={{ width: { xs: "80%", md: "100%" }, pl: 2 }}
            >
              <Button
                variant="contained"
                fullWidth
                sx={{
                  // backgroundColor: theme.palette.primary.main,
                  width: { xs: "50%", md: "10%" },
                }}
              >
                <Link
                  // to={`https://staging.spitimou.cy/auth/register?provider=ecard&userId=${uid}`}
                  to={"https://spitimou.cy/"}
                  style={{ color: "white", textDecoration: "none" }}
                >
                  to spitimou
                </Link>
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12} sx={{ pt: 2 }}>
            <Grid
              container
              justifyContent={{ xs: "flex-start", md: "center" }}
              sx={{ width: { xs: "80%", md: "100%" }, pl: 2 }}
            >
              <Button
                variant="contained"
                fullWidth
                sx={{
                  // backgroundColor: theme.palette.primary.main,
                  width: { xs: "50%", md: "10%" },
                }}
              >
                <Link
                  to={"https://spitimou.cy/"}
                  style={{ color: "white", textDecoration: "none" }}
                >
                  to spitimou
                </Link>
              </Button>
            </Grid>
          </Grid>
        )}
        {managerID === uid ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            sx={{ p: "15px" }}
          >
            <Grid item alignItems="center">
              <Link to={`/${uid}/addnewproperty`} state={managerID}>
                <Button
                  variant="outlined"
                  sx={{
                    color: "white",
                    backgroundColor: "#1B1A55",
                    borderRadius: "5px",
                    width: "250px",
                  }}
                >
                  Add New Property
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ p: "15px" }}
              >
                <LogOutButton />
              </Grid>
            </Grid>
          </Grid>
        ) : managerID === null ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            sx={{ p: "15px" }}
          >
            <Grid item alignItems="center">
              <Link to="/login_s" style={{ textDecoration: "none" }}>
                <Button
                  variant="outlined"
                  sx={{
                    color: "white",
                    backgroundColor: "#1B1A55",
                    borderRadius: "5px",
                    width: "250px",
                  }}
                >
                  Login
                </Button>
              </Link>
            </Grid>
          </Grid>
        ) : null}
      </Grid>
      {/* <Grid item>
          <Button
            variant="outlined"
            sx={{
              borderRadius: "5px",
              backgroundColor: theme.palette.primary.main,
              color: "white",
              width: "110px",
            }}
          >
            nearby
          </Button>
        </Grid> */}
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        sx={{ pb: "20px" }}
      >
        <Grid item xs={6}>
          <SearchButton />
        </Grid>
        <Grid item xs={6}>
          {Object.keys(reduxQuerySelector).length > 0 ? (
            <Button
              onClick={() => {
                handleClear();
                reloadPage();
              }}
            >
              Clear Search
            </Button>
          ) : null}
        </Grid>
      </Grid>
      <Typography sx={{ pb: 2 }}>
        {allProperties.data?.list.length} Properties
      </Typography>
      <Grid
        container
        size={12}
        justifyContent={"center"}
        alignItems={"center"}
        sx={{ width: "100%" }}
      >
        {
          // 1. Search loading
          searchLoading ? (
            <CustomLoader />
          ) : // 2. Initial load before any data exists
          !allProperties?.data ? (
            <CustomLoader />
          ) : // 3. LIST EXISTS BUT EMPTY → check if it's initial load or search
          Array.isArray(allProperties.data.list) &&
            allProperties.data.list.length === 0 ? (
            searchDone ? (
              <Typography sx={{ p: 2, fontSize: "18px", opacity: 0.7 }}>
                No properties found
              </Typography>
            ) : (
              <Typography sx={{ p: 2, fontSize: "18px", opacity: 0.7 }}>
                There are no properties yet
              </Typography>
            )
          ) : // 4. SHOW LIST WHEN IT EXISTS AND HAS ITEMS
          Array.isArray(allProperties.data.list) ? (
            allProperties.data.list.map((property) => (
              <Grid
                item
                key={property.id}
                sx={{ p: "10px" }}
                onClick={() =>
                  handleListCardClick(property.id, property.secure_num)
                }
              >
                <PropertyCard
                  propertyId={property.id}
                  propertySecureNum={property.secure_num}
                  propertyName={property.title}
                  propertyImage={property.image}
                  propertyAddress={property.street}
                  propertyPrice={property.price}
                  propertyType={property.re_type}
                  rooms={property.rooms}
                  baths={property.bathrooms}
                  parking={property.parking}
                  propertySqm={property.square}
                  propertySqmType={property.square_type}
                  saleOrRent={property.deal_type}
                  fornitured={property.furnished}
                  coin={property.coin}
                  agentPhoneNumber={property.re_phone1}
                  waze={property.waze}
                  managerID={managerID}
                  spitimou_rid={property.spitimou_rid}
                />
              </Grid>
            ))
          ) : (
            // 5. fallback (should never run)
            <Typography sx={{ p: 2, fontSize: "18px", opacity: 0.7 }}>
              No properties found
            </Typography>
          )
        }
      </Grid>
    </Grid>
  );
};

export default PropertyList;
